import {
  Popover,
  PopoverContent,
  PopoverHandler,
  Typography
} from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { FilterButton } from '../action-buttons'

export const FilterPopover = ({ children, popoverContentProps }) => {
  const { t } = useTranslation()

  return (
    <Popover placement='bottom-end' className='absolute'>
      <PopoverHandler>
        <div>
          <FilterButton />
        </div>
      </PopoverHandler>
      <PopoverContent {...popoverContentProps}>
        <Typography variant='h6' color='blue-gray' className='mb-6'>
          {t('filters.other')}
        </Typography>
        {children}
      </PopoverContent>
    </Popover>
  )
}

FilterPopover.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  handler: PropTypes.func,
  popoverContentProps: PropTypes.object
}

FilterPopover.defaultProps = {
  open: false,
  popoverContentProps: {
    className: 'w-96 p-5 z-50'
  }
}
